export const vehicleCategories = [
  {
    label: 'Cabriolet',
    value: 'cabriolet',
    defaultConsumption: 7.8, // L/100km
  },
  {
    label: 'Coupé',
    value: 'coupe',
    defaultConsumption: 7.2, // L/100km
  },
  {
    label: 'Break',
    value: 'break',
    defaultConsumption: 6.5, // L/100km
  },
  {
    label: 'Compacte',
    value: 'compacte',
    defaultConsumption: 5.6, // L/100km
  },
  {
    label: 'Monospace',
    value: 'monospace',
    defaultConsumption: 7.5, // L/100km
  },
  {
    label: 'Pick-up',
    value: 'pickup',
    defaultConsumption: 9.2, // L/100km
  },
  {
    label: 'SUV/4x4',
    value: 'suv',
    defaultConsumption: 8.4, // L/100km
  },
];
